import { render, staticRenderFns } from "./ServiceProviderChart.vue?vue&type=template&id=745e7740&"
import script from "./ServiceProviderChart.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports